const { useEffect } = wp.element;

const Style = ({ attributes, setAttributes }) => {
  const { CSS, width, uniqueId, align } = attributes;

  useEffect(() => {
    // const playerWidth = typeof width === "object" ? (width.number === 0 ? "100%" : width.number + width.unit) : width;
    const playerWidth = typeof width === "object" ? `${width.number}${width.unit}` : width;
    const generatedCSS = `#${uniqueId}{justify-content: ${align}}#${uniqueId} {float: none;}#${uniqueId} .simplePlaylist {width: ${playerWidth}}`;
    setAttributes({ CSS: generatedCSS });
  }, [width, uniqueId, align]);

  return <style>{CSS}</style>;
};

export default Style;
